import svgPaths from '@/assets/svg-icons';

export const ToastStatus = {
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success',
} as const;

export type ToastStatusKey = (typeof ToastStatus)[keyof typeof ToastStatus];

export const ProgramCodes = {
  FILE_LIBRARY: 'fileLibrary',
  RESOURCE_REQUEST: 'resourceRequest',
  PATIENT_TRANSFER: 'patientTransfer',
  MOD: 'mod',
  FAQ: 'faq',
} as const;

export type ProgramCodeKey = (typeof ProgramCodes)[keyof typeof ProgramCodes];

export const ProgramTitles = {
  FILE_LIBRARY: 'File Library',
  RESOURCE_REQUEST: 'Resource Request',
  PATIENT_TRANSFER: 'Patient Transfer',
  MOD: 'Message of the Day',
  FAQ: 'Frequently Asked Questions',
} as const;

export type ProgramTitleKey = (typeof ProgramTitles)[keyof typeof ProgramTitles];

export const SpecialPermission = {
  COORDINATOR: 'C',
  ADMINISTRATOR: 'A',
  READ_ONLY: 'R',
  HOSPITAL: 'H',
};

export type SpecialPermissionKey = (typeof SpecialPermission)[keyof typeof SpecialPermission];

export const RequestStatus = {
  REQUEST: 'Request',
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  RECEIVED: 'Received',
  CANCELLED: 'Cancelled',
  FORWARDED: 'Forwarded',
  PARTIAL: 'Partial',
  DENIED: 'Denied',
};

export type RequestStatusKey = (typeof RequestStatus)[keyof typeof RequestStatus];

export const TransferStatusEnum = {
  REQUEST: 'Request',
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  CANCELLED: 'Cancelled',
  ONHOLD: 'On Hold',
  PARTIAL: 'Partially Accepted',
  RELEASED: 'Released',
};

export type TransferStatusKey = (typeof TransferStatusEnum)[keyof typeof TransferStatusEnum];

export const FulfillmentDeliveryStatus = {
  WILL_DELIVER: 'Willing to deliver',
  NOT_DELIVER: 'Unable to deliver',
};

export type FulfillmentDeliveryStatusKey =
  (typeof FulfillmentDeliveryStatus)[keyof typeof FulfillmentDeliveryStatus];

export const FulfillmentStatus = {
  ACCEPTED: 'Accepted',
  DENIED: 'Denied',
  PENDING: 'Pending',
};

export type FulfillmentStatusKey = (typeof FulfillmentStatus)[keyof typeof FulfillmentStatus];

export const PTRequestStepForm = {
  RECIPIENTS: 'recipients',
  CONTENT: 'content',
};

export type PTRequestStepFormKey = (typeof PTRequestStepForm)[keyof typeof PTRequestStepForm];

export const UserStatus = {
  APPROVED: 'Approved',
  SUSPENDED: 'Suspended',
  PENDING: 'Pending Approval',
  NOT_APPROVED: 'Not Approved',
};

export type UserStatusKey = (typeof UserStatus)[keyof typeof UserStatus];

export const AreaName = {
  PEE_DEE_COUNTIES: 'Pee Dee',
  LOW_COUNTY_COUNTIES: 'Lowcountry',
  MIDLANDS_COUNTIES: 'Midlands',
  UPSTATE_COUNTIES: 'Upstate',
};

export type AreaNameKey = (typeof AreaName)[keyof typeof AreaName];

export const SVGIconName = {
  CARD: 'card',
  SEARCH: 'search',
  CHECKED: 'checked',
  BIG_X: 'bigX',
  MENU: 'menu',
  CROSS: 'cross',
  WEB_ASSET: 'webAsset',
  PERSON: 'person',
  CLOSE: 'close',
  INFO: 'info',
  CHECK_OUTLINED: 'checkOutlined',
  CONTACT: 'contact',
  INFO_OUTLINED: 'infoOutlined',
};

export type SVGIconNameKey = keyof typeof svgPaths;

export const ForgotFormSteps = {
  STEP1: 1,
  STEP2: 2,
  STEP3: 3,
};

export const RegionalCoordinatorArea = {
  LOWCOUNTRY: 'Lowcountry',
  MIDLANDS: 'Midlands',
  UPSTATE: 'Upstate',
  PEE_DEE: 'Pee Dee',
};

export type RegionalCoordinatorAreaKey =
  (typeof RegionalCoordinatorArea)[keyof typeof RegionalCoordinatorArea];

export const AppStatusEnum = {
  GRANT: 'grant',
  REVOKE: 'revoke',
} as const;

export type AppStatusEnumKey = (typeof AppStatusEnum)[keyof typeof AppStatusEnum];

export const PatientTransferType = {
  INDIVIDUAL: 'individual',
  BULK: 'bulk',
};

export type PatientTransferTypeKey = (typeof PatientTransferType)[keyof typeof PatientTransferType];

export const BlastEmailStepForm = {
  RECIPIENTS: 'recipients',
  CONTENT: 'content',
};

export type BlastEmailStepFormKey = (typeof BlastEmailStepForm)[keyof typeof BlastEmailStepForm];

export const BlastEmailMessageTypeEnum = {
  MESSAGE: 'message',
  CONTACTS: 'contacts',
} as const;

export const PTBlastEmailMessageTypeEnum = {
  HURRICANE: 'hurricane',
  LOCAL_REGIONAL: 'local_regional',
} as const;

export const OrganizationFormTab = {
  DETAILS: 'Details',
  INVENTORY: 'Inventory',
};

export type OrganizationFormTabKey = (typeof OrganizationFormTab)[keyof typeof OrganizationFormTab];

export const InventoryResourceType = {
  EQUIPMENT: 'Equipment',
  COMMODITY: 'Commodity',
};
